
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-messages-popup',
  templateUrl: './messages-popup.component.html',
  styleUrls: ['./messages-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})

export class MessagesPopupComponent implements OnInit {

  @Input("personalizedMsg") personalizedMsg!: any;

  constructor(private modalCtrl: ModalController) { }

  async dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() { }

  ionViewDidEnter() {
    // console.log(this.personalizedMsg);
  }
}
